import "./App.scss";

import LandingPage from "./components/LandingPage/LandingPage";

function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;
